<template>
  <nav class="container pt-15 overflow-auto">
    <ol
      ref="list"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
      class="flex breadcrumb"
    >
      <li
        v-for="(link, index) in links"
        :key="index"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
        class="uppercase font-semibold text-xs flex items-center h-[40px]"
        :class="{
          'pr-25': index === links.length - 1,
        }"
      >
        <VuepalLink
          itemprop="item"
          :to="link.url.path"
          class="py-5 hover:opacity-60"
          :class="{
            'text-gray-dark pointer-events-none': index === links.length - 1,
          }"
        >
          {{ link.title }}
        </VuepalLink>
        <SpriteSymbol
          v-if="index < links.length - 1"
          name="arrow"
          class="size-[0.7em] mx-[1em] mt-[-0.09em]"
        />
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import type { BreadcrumbFragment } from '#graphql-operations'

defineProps<{
  links: BreadcrumbFragment[]
}>()
</script>
